import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
	setCreateCollaboratorModal,
	setDeleteCollaboratorModal,
	setSelectedCollaborator
} from '@/store/collaborators';
import { sendCollaboratorInvitation } from '@/store/collaborators/thunks';
import { showError, showSuccess } from '@/utils';

export const useActions = ({ row }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const user = useSelector(state => state.profile.user);

	const handleSendInvitation = () => {
		dispatch(sendCollaboratorInvitation(row.original.id))
			.unwrap()
			.then(() => {
				showSuccess(t('users.table.inviteSent'));
			})
			.catch(error => {
				showError(error);
			});
	};

	const handleDeleteCollaborator = () => {
		dispatch(setDeleteCollaboratorModal(true));
		dispatch(setSelectedCollaborator(row.original));
	};

	const handleEditCollaborator = () => {
		dispatch(setCreateCollaboratorModal(true));
		dispatch(setSelectedCollaborator(row.original));
	};

	return {
		handleSendInvitation,
		handleDeleteCollaborator,
		handleEditCollaborator,
		isDisabled: user.id === row.original.id,
		isOwner: !row.original.parentAccount
	};
};
